// @generated by liquid-inject from src/sections/algolia-header-search/algolia-header-search.ts
// src/sections/algolia-header-search/algolia-header-search.ts
var PANEL_SPECIFIER = "@theme/algolia-header-panel";
var AlgoliaHeaderSearch = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.abortController = null;
    this.dialog = null;
    this.emptyState = null;
    /** Resolved once; a second open reuses the in-flight or settled promise. */
    this.panelModule = null;
    this.handleKeydown = (event) => {
      if (event.key === "Escape" && this.dialog?.open) {
        event.preventDefault();
        this.toggleDialog();
      }
      if (event.key === "k" && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        this.toggleDialog();
      }
    };
    this.toggleDialog = () => {
      if (!this.dialog) return;
      if (this.dialog.open) {
        this.closeDialog();
        return;
      }
      document.documentElement.classList.add("is-overflow-hidden");
      this.dialog.showModal();
      void this.openPanel();
    };
    // Successful add to cart (event bubbled by `<c-product-form>` inside the
    // panel): close the search to reveal the cart popup / re-rendered cart page.
    // Section refreshing (main-cart, cart-summary, header…) is handled by
    // CProductForm via `data-is-cart` + the form's `sections` list.
    this.handleAddSuccess = () => {
      this.closeDialog();
    };
  }
  connectedCallback() {
    const { algoliaAppId, algoliaApiKey } = this.dataset;
    if (!algoliaAppId || !algoliaApiKey) return;
    this.dialog = this.querySelector("[data-search-dialog]");
    this.emptyState = this.querySelector("[data-empty-state]");
    this.bindEvents();
    this.showEmptyState();
  }
  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }
  bindEvents() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    document.querySelectorAll("[data-btn-toogle-search]").forEach(
      (button) => button.addEventListener("click", this.toggleDialog, { signal })
    );
    this.addEventListener("cart:add-success", this.handleAddSuccess, { signal });
    window.addEventListener("keydown", this.handleKeydown, { signal });
  }
  /**
   * The dialog is shown first and the panel is fetched after, on purpose: the
   * empty state (recent searches, trending) is rendered by Liquid and is already
   * on screen, so the user sees the search open immediately even on a cold
   * network. The module load only gates typing into it.
   */
  async openPanel() {
    if (!this.panelModule) {
      this.panelModule = import(
        /* @vite-ignore */
        PANEL_SPECIFIER
      );
    }
    try {
      const { mountHeaderPanel } = await this.panelModule;
      await mountHeaderPanel(this);
    } catch (error) {
      this.panelModule = null;
      console.warn("[algolia-header-search] panel failed to load", error);
    }
  }
  closeDialog() {
    if (!this.dialog?.open) return;
    document.documentElement.classList.remove("is-overflow-hidden");
    this.dialog.close();
  }
  showEmptyState() {
    this.dataset.state = "empty";
    this.emptyState?.removeAttribute("hidden");
  }
};
if (!window.customElements.get("c-algolia-header-search")) {
  window.customElements.define("c-algolia-header-search", AlgoliaHeaderSearch);
}
